import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AccounDataDTO, ClientDTO, ClientService, LookUpService, UserDTO, UserService } from 'synergy-core';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';
declare var $: any;

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.sass']
})
export class ClientComponent implements OnInit {
  selectedId!: string
  activeIndex: number = 0;
  data!: ClientDTO;
  items!: MenuItem[];
  personTypes!: any[];
  countries!: any[];
  states!: any[];
  cities!: any[];
  districts!: any[];
  economicActivities!: any[];
  nighboorhoods!: any[];
  isPhysicalPerson: boolean = false;
  organizationForm!: FormGroup
  organizationSubmitted: boolean = false;
  loading = false;
  buttonDisabled: boolean = false;
  entityName: string = "Configuracion"
  entityDescription: string = "Mantemiento de datos del cliente y configuracion de la aplicacion"
  currentUser!: AccounDataDTO;
  imageFile: any;
  imageMessage!: string;
  inputFile: any;
  constructor(private lookupDataService: LookUpService,
    private clientService: ClientService,
    private router: Router) { }

  ngOnInit() {
    this.setOrganizationForm();
    this.getData();
    this.getPersonTypes();
    this.getTabItems();
    this.getCountries();
    this.getEconomicActivities(1);
   // 
  }

  getData(){
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    console.log(0);

    this.clientService.GetById(this.currentUser.ClientId).subscribe(val => {
      console.log(1);
      console.log(val);
      this.data = val.Data[0];
      this.setOrganizationFormData(); 
    });
  }


  onClearImage() {
    $("#inputFile").val('');
    this.imageFile = null;
    this.imageMessage = null!;
    this.organizationForm.controls["imageURL"].setValue("");
  }

  onSearchImage() {
    $("#inputFile").trigger('click');
  }
  onFileChange(files: any) {
    if (files.length === 0)
      return;
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.imageMessage = "Tipo de archivo no soportado.";
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.organizationForm.controls["imageURL"].setValue(files[0].name);
      this.imageFile = reader.result;
      this.organizationForm.controls["base64String"].setValue(this.imageFile.substr(this.imageFile.indexOf(',') + 1));
    }
  }


  setOrganizationFormData() {
    var timestamp = new Date();

    setTimeout(() => {
      this.onSelectCountry(this.data.CountryId);
    }, 50);
    setTimeout(() => {
      this.onSelectState(this.data.StateId);
    }, 50);
    setTimeout(() => {
      this.onSelectCity(this.data.CityId);
    }, 50);
    setTimeout(() => {
      this.onSelectDistrict(this.data.DistrictId);
    }, 50);

    setTimeout(() => {
      this.organizationForm.controls["id"].setValue(this.data.Id);
      this.organizationForm.controls["economicActivityId"].setValue(this.data.EconomicActivityId);
      this.organizationForm.controls["personTypeId"].setValue(this.data.PersonTypeId);
      this.organizationForm.controls["identification"].setValue(this.data.Identification);
      this.organizationForm.controls["name"].setValue(this.data.Name);
      this.organizationForm.controls["lastName"].setValue(this.data.LastName);
      this.organizationForm.controls["comercialName"].setValue(this.data.ComercialName);
      this.organizationForm.controls["emailAddress"].setValue(this.data.EmailAddress);
      this.organizationForm.controls["phoneNumber1"].setValue(this.data.PhoneNumber1);
      this.organizationForm.controls["phoneNumber2"].setValue(this.data.PhoneNumber2);
      this.organizationForm.controls["countryId"].setValue(this.data.CountryId);
      this.organizationForm.controls["stateId"].setValue(this.data.StateId);
      this.organizationForm.controls["cityId"].setValue(this.data.CityId);
      this.organizationForm.controls["districtId"].setValue(this.data.DistrictId);
      this.organizationForm.controls["neighborhoodId"].setValue(this.data.NeighborhoodId);
      this.organizationForm.controls["address"].setValue(this.data.Address);
      this.organizationForm.controls["isActive"].setValue(this.data.IsActive);
    }, 50);

    if(this.data.ImageURL){
      this.imageFile = null;
      this.imageFile = environment.imagesURL + this.data.ImageURL + '?' + timestamp.toTimeString();
    } else{
      this.imageFile = null;
    }

  }

    setOrganizationForm(){
    this.organizationForm = new FormGroup({
      id: new FormControl('', [Validators.required]),
      economicActivityId: new FormControl(null, [Validators.required]),
      personTypeId: new FormControl(null, [Validators.required]),
      identification: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required]),
      lastName: new FormControl(null),
      comercialName: new FormControl(),
      emailAddress: new FormControl(null, [Validators.required, Validators.email]),
      phoneNumber1: new FormControl("(506)", [Validators.required]),
      phoneNumber2: new FormControl(),
      countryId: new FormControl(null, [Validators.required]),
      stateId: new FormControl(null, [Validators.required]),
      cityId: new FormControl(null, [Validators.required]),
      districtId: new FormControl(null, [Validators.required]),
      neighborhoodId: new FormControl(null),
      imageURL: new FormControl(null),
      base64String: new FormControl(null),
      address: new FormControl(null, [Validators.required, Validators.maxLength(500)]),
      isActive: new FormControl(true, [Validators.required, Validators.maxLength(500)]),
    });

    this.organizationForm.disable();

  }


  get organizationControls() { return this.organizationForm.controls; }

  getPersonTypes() {
    this.lookupDataService.getPersonTypes().subscribe(data => {
      if (data) {
        this.personTypes = data;
      }
    });
  }

  getTabItems() {
    this.items = [{
      label: 'Organizacion',
      command: (event: any) => {
        this.activeIndex = 0;
      }
    },
    {
      label: 'Cuenta de Usuario',
      command: (event: any) => {
        this.activeIndex = 1;
      }
    },
    {
      label: 'Confirmacion',
      command: (event: any) => {
        this.activeIndex = 3;
      }
    }];
  }


  onEdit() {
    if (this.selectedId != '') {
      this.organizationForm.enable();
      this.buttonDisabled = true;
    }
  }

  
  getCountries() {
    this.lookupDataService.GetCountries().subscribe(val => {
      this.countries = val.Data;
    });
  }

  getEconomicActivities(countryId: number) {
    this.lookupDataService.GetEconomicActivities(countryId).subscribe(val => {
      this.economicActivities = val.Data;
    });
  }

  onSelectCountry(id: number) {
    this.lookupDataService.GetStatesByCountryId(id).subscribe(data => {
      if (data) {
        this.states = data.Data;
      }
    });
  }

  onSelectState(id: number) {
    this.lookupDataService.GetCityByStateId(id).subscribe(data => {
      if (data) {
        this.cities = data.Data;
      }
    });
  }

  onSelectCity(id: number) {
    this.lookupDataService.GetDistrictByCityId(id).subscribe(data => {
      if (data) {
        this.districts = data.Data;
      }
    });
  }

  onSelectDistrict(id: number) {
    this.lookupDataService.GetNeighborhoodByDistrictId(id).subscribe(data => {
      if (data) {
        this.nighboorhoods = data.Data;
      }
    });
  }

  onSubmit() {
    console.log(1);
    this.organizationSubmitted = true;
    if (this.organizationForm.invalid) {
      console.log(this.organizationForm);
      return;
    }

    this.loading = true;
    let organizationDto = new ClientDTO();
    organizationDto.Id = this.organizationForm.value.id;
    organizationDto.ClientId = '00000000-0000-0000-0000-000000000000';
    organizationDto.ApplicationId = environment.applicayionId;
    organizationDto.PersonTypeId = this.organizationForm.value.personTypeId;
    organizationDto.Identification = this.organizationForm.value.identification;
    organizationDto.Name = this.organizationForm.value.name;
    organizationDto.ComercialName = this.organizationForm.value.comercialName;
    organizationDto.LastName = this.organizationForm.value.lastName; //TODO
    organizationDto.CityId = this.organizationForm.value.cityId;
    organizationDto.StateId = this.organizationForm.value.stateId;
    organizationDto.DistrictId = this.organizationForm.value.districtId;
    organizationDto.StateId = this.organizationForm.value.stateId;
    organizationDto.CountryId = this.organizationForm.value.countryId;
    organizationDto.NeighborhoodId = this.organizationForm.value.neighborhoodId;
    organizationDto.Address = this.organizationForm.value.address;
    organizationDto.Detail = this.organizationForm.value.detail;
    organizationDto.PhoneNumber1 = this.organizationForm.value.phoneNumber1;
    organizationDto.EmailAddress = this.organizationForm.value.emailAddress;
    organizationDto.IsActive = true;
    organizationDto.EconomicActivityId = this.organizationForm.value.economicActivityId;
    organizationDto.CreatedBy = this.currentUser.Id;
    organizationDto.CreatedDate = new Date();
    organizationDto.Detail = "";
    organizationDto.ImageURL = this.organizationForm.value.imageURL;
    organizationDto.Base64StringImage = this.organizationForm.value.base64String;

    this.clientService.Update(organizationDto).pipe(
      finalize(() => {
        this.organizationSubmitted = false;
        this.loading = false;
      }),
      catchError((error) => {
        throw error;
      })
    ).subscribe((data) => {
      if (data && data.Success) {
        this.organizationForm.enable();
        this.buttonDisabled = false;
      }
    });

  }

  onSubmitConfirmation() {

    this.loading = true;
    let organizationDto = new ClientDTO();
    organizationDto.Id = '00000000-0000-0000-0000-000000000000';
    organizationDto.ClientId = '00000000-0000-0000-0000-000000000000';
    organizationDto.ApplicationId = environment.applicayionId;
    organizationDto.PersonTypeId = this.organizationForm.value.personTypeId;
    organizationDto.Identification = this.organizationForm.value.identification;
    organizationDto.Name = this.organizationForm.value.name;
    organizationDto.ComercialName = this.organizationForm.value.comercialName;
    organizationDto.LastName = this.organizationForm.value.lastName; //TODO
    organizationDto.CityId = this.organizationForm.value.cityId;
    organizationDto.StateId = this.organizationForm.value.stateId;
    organizationDto.DistrictId = this.organizationForm.value.districtId;
    organizationDto.StateId = this.organizationForm.value.stateId;
    organizationDto.CountryId = this.organizationForm.value.countryId;
    organizationDto.NeighborhoodId = this.organizationForm.value.neighborhoodId;
    organizationDto.Address = this.organizationForm.value.address;
    organizationDto.Detail = this.organizationForm.value.detail;
    organizationDto.PhoneNumber1 = this.organizationForm.value.phoneNumber1;
    organizationDto.EmailAddress = this.organizationForm.value.emailAddress;
    organizationDto.IsActive = true;
    organizationDto.EconomicActivityId = this.organizationForm.value.economicActivityId;
    organizationDto.CreatedBy = '00000000-0000-0000-0000-000000000000';
    organizationDto.CreatedDate = new Date();

    this.clientService.Create(organizationDto).pipe(
      finalize(() => {
        this.organizationSubmitted = false;
        this.loading = false;
      }),
      catchError((error) => {
        throw error;
      })
    ).subscribe((data) => {
      if (data && data.Success) {
      }
    });
  }

  onPersonTypeChange(personTypeId: any) {
    this.isPhysicalPerson = false;
    if (personTypeId == 1) {
      this.isPhysicalPerson = true;
    }
  }

  onCancel() {
    this.organizationForm.disable();
    this.buttonDisabled = false;
  }
}
